import { getV2 } from './client';
import fallbackProjects from '../data/projects';

export async function fetchProjects() {
  try {
    const res = await getV2('/products.php');
    if (res?.status === 'success' && Array.isArray(res?.data?.items)) {
      return res.data.items;
    }
  } catch (error) {
    // fallback keeps the page stable even if v2 endpoint is unavailable
  }

  return fallbackProjects;
}
